import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authLogout, authMe, setOnUnauthorized } from "../lib/api";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../lib/testMode";

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(async () => {
    const refresh = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (refresh) {
      try { await authLogout(refresh); } catch { /* ignore */ }
    }
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    setUser(null);
  }, []);

  // Bootstrap: se c'è un access_token, prova a recuperare l'utente
  useEffect(() => {
    setOnUnauthorized(() => {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      setUser(null);
    });
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (!token) {
      setLoading(false);
      return;
    }
    authMe()
      .then(setUser)
      .catch(() => {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await authLogin(email, password);
    localStorage.setItem(ACCESS_TOKEN_KEY, data.access_token);
    localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const refreshMe = async () => {
    const u = await authMe();
    setUser(u);
    return u;
  };

  const isAdmin = user?.ruolo === "AMMINISTRATORE";
  const isOffice = user?.ruolo === "UFFICIO";
  const isCarrier = user?.ruolo === "TRASPORTATORE";
  const canSeeCommercial = isAdmin || isOffice;

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout, refreshMe,
      isAdmin, isOffice, isCarrier, canSeeCommercial,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
